import { render, staticRenderFns } from "./jobCardDetails.vue?vue&type=template&id=73e4fa50&scoped=true"
import script from "./jobCardDetails.vue?vue&type=script&lang=js"
export * from "./jobCardDetails.vue?vue&type=script&lang=js"
import style0 from "./jobCardDetails.vue?vue&type=style&index=0&id=73e4fa50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4fa50",
  null
  
)

export default component.exports